import { SectionHeader, BfiCustomStore } from '../../common/SharedComponents';
import store, { searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import ApplicationReviewModal from './modals/ApplicationReviewModal';
import DeclineOrRecycleModal from '../common/modals/DeclineOrRecycleModal';
import AppraisalModal from '../appraise/modals/AppraisalModal';
import debounce from 'lodash.debounce';
import RollbackModal from '../common/modals/RollbackModal';
import ConvertToLoanModal from '../appraise/modals/ConvertToLoanModal';
import ChangeLoanTypeModal from '../common/modals/ChangeLoanTypeModal';
import SubmittedNonRentalsTable from './tables/SubmittedNonRentalsTable';
import SubmittedBridgeTable from './tables/SubmittedBridgeTable';
import SubmittedRentalsTable from './tables/SubmittedRentalsTable';
import MovePropertiesModal from '../common/modals/MovePropertiesModal';
import AuditHistoryModal from '../common/modals/AuditHistoryModal';
import PrincipalSwapModal from '../common/modals/PrincipalSwapModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function SubmittedAppsLanding() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;
    const debouncedSearch = debounce(dispatch, 500);

    const nonRentalsGridStore = new BfiCustomStore();
    const locGridStore = new BfiCustomStore();
    const bridgeGridStore = new BfiCustomStore();
    const rentalsGridStore = new BfiCustomStore();

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    application: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <SectionHeader title='Submitted Applications' />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search on BFI Number, City, State, Borrower or User...'
                        defaultValue={searchState?.searchText?.application}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div
                    className='scrollable-content'
                    style={{ padding: '1rem' }}
                >
                    <div
                        className='applications accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <SubmittedNonRentalsTable
                            key='NonRentalsTable'
                            isLOC={false}
                            gridStore={nonRentalsGridStore}
                        />
                        <SubmittedNonRentalsTable
                            key='LOCTable'
                            isLOC={true}
                            gridStore={locGridStore}
                        />
                        <SubmittedBridgeTable
                            key='BridgeTable'
                            gridStore={bridgeGridStore}
                        />
                        <SubmittedRentalsTable
                            key='RentalsTable'
                            gridStore={rentalsGridStore}
                        />
                    </div>
                </div>
            </div>
            <ApplicationReviewModal />
            <AppraisalModal />
            <RollbackModal />
            <DeclineOrRecycleModal />
            <ConvertToLoanModal />
            <ChangeLoanTypeModal />
            <MovePropertiesModal />
            <AuditHistoryModal />
            <PrincipalSwapModal />
        </>
    );
}

export default SubmittedAppsLanding;
